import { withServerSideProps } from '@/containers/withServerSideProps'
import { getServerDocxHtmlString } from '@/containers/withServerDoc'
import DocxRenderComponent from '@/pages/about/components/DocxRenderComponent'

export default function AboutAgreement({ htmlContent }) {
  return (
    <div className="bg-white flex-1">
      <DocxRenderComponent html={htmlContent} />
    </div>
  )
}

const getServerSideProps = withServerSideProps(async () => {
  return {
    props: {
      htmlContent: await getServerDocxHtmlString(
        `https://res.gengesports.cn/user-web/doc/en/agreement.htm`
      ),
    },
  }
})

export { getServerSideProps }
